import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as $ from "jquery";
import RootView from "./root-view";
import ModalView from "../modals/controller";
import SimpleButtonView from "../button-logic/simple-buttons-view";
import {repair} from "../utils/repair-renderer";
import {getParams} from "../utils/get-params";

declare global {
    interface Window {
        madeTarget: string;
        CMS: {
            config: {
                mode: string;
            }
        };
        DJANGO: {
            staticUrl: string;
        }
    }
}


const app = new Marionette.Application();

app.once("start", () => {
    const modalId = getParams(window.location.search)["modal"];
    repair();
    this.rootView = new RootView().render();
    this.madeButtonView = new SimpleButtonView().render();
    this.modalView = new ModalView().render();

    if (modalId) {
        this.modalView.deepLinkModal(modalId);
    }

    const madeTarget = window.madeTarget;
    if (madeTarget) {

        const element = document.querySelector(`#${madeTarget}`);

        if(element) {
            element.scrollIntoView({
                block: 'center',
                inline: 'center'
            });
        }
    }
});

$(() => {
    // Wraps any tables within the `rich-text` areas with a `div.table-wrapper` element to handle when it is on a small screen
    document.querySelectorAll('.rich-text table').forEach(table => {
        const wrap = document.createElement('div');
        wrap.classList.add('table-wrapper');
        table.parentNode.insertBefore(wrap, table);
        wrap.appendChild(table);
    });

    document.querySelectorAll('.soundcloud-embed table').forEach(table => {
        const wrap = document.createElement('div');
        wrap.classList.add('table-wrapper');
        table.parentNode.insertBefore(wrap, table);
        wrap.appendChild(table);
    });

    app.start();
});



// WEBPACK FOOTER //
// ./@modules/web/index.ts